import React from 'react'
import Seo from '../Seo/Seo'
import Hero from './HomeComponent/Hero'
import IndustryProgram from './HomeComponent/IndustryProgram'
import IndustryNeed from './HomeComponent/IndustryNeed'
import OurApproach from './HomeComponent/OurApproach'
import InnovativeCurriculomn from './HomeComponent/InnovativeCurriculomn'
import HandsOnLearning from './HomeComponent/HandsOnLearning'
import IndustryPartnerships from './HomeComponent/IndustryPartnerships'
import FlexibleDelievery from './HomeComponent/FlexibleDelievery'
import EmpoweringEducators from './HomeComponent/EmpoweringEducators'
import ReadyToDeploy from './HomeComponent/ReadyToDeploy'

const Home = () => {
  return (
    <>
    <Seo
      title='CLI | Industry-aligned programs for colleges and students'
      description='CLI bridges the gap between education and industry with industry-aligned programs, hands-on learning and mentorship that make students work-ready.'
      path='/'
    />
    <Hero />
    <IndustryProgram />
    <IndustryNeed />
    <ReadyToDeploy />
    <OurApproach />
    <InnovativeCurriculomn />
    <HandsOnLearning />
    <IndustryPartnerships />
    <FlexibleDelievery />
    <EmpoweringEducators />
    </>
  )
}

export default Home